import { theme } from "../../../theme"

type PopperTheme = {
  primaryColor: string
  color: string
  background: string
  buttonTextColor: string
  textColor: string
}

export const PopperDarkTheme: PopperTheme = {
  primaryColor: theme.color.white,
  color: theme.color.white,
  background: theme.color.black6,
  buttonTextColor: theme.color.black6,
  textColor: theme.color.white,
}

export const PopperLightTheme: PopperTheme = {
  primaryColor: theme.color.blue2,
  color: theme.color.black3,
  background: theme.color.white,
  buttonTextColor: theme.color.white,
  textColor: theme.color.black6,
}
